import { ref } from 'vue'

/**
 * @param {{
 *   settingDone: Boolean
 * }} props
 */
export const setup = props => {
  const self = {
    modalVisible: ref(props.settingDone),

    closeModal: () => {
      self.modalVisible.value = false
      return self
    },
  }

  return {
    // props
    modalVisible: self.modalVisible,

    // functions
    closeModal: self.closeModal,
  }
}
